import {
  RECEIVE_DOCS_GOOGLE_DRIVE_REQUEST,
  RECEIVE_DOCS_GOOGLE_DRIVE_SUCCESS,
  RECEIVE_DOCS_GOOGLE_DRIVE_ERROR,
  ADD_NEW_FILES_GOOGLE_DRIVE_REQUEST,
  ADD_NEW_FILES_GOOGLE_DRIVE_SUCCESS,
  ADD_NEW_FILES_GOOGLE_DRIVE_ERROR,
  SEND_NEW_FILES_GOOGLE_DRIVE_REQUEST,
  SEND_NEW_FILES_GOOGLE_DRIVE_SUCCESS,
  SEND_NEW_FILES_GOOGLE_DRIVE_ERROR,
} from "../../../common/constants/action-constants";
// import AlertService from "../../../common/services/notification.service";
import {
  IAddNewFilesGoogleDriveErrorAction,
  IAddNewFilesGoogleDriveRequestAction, IAddNewFilesGoogleDriveSuccessAction, ISendNewFilesGoogleDriveErrorAction,
  ISendNewFilesGoogleDriveRequestAction, ISendNewFilesGoogleDriveSuccessAction,
  IUploadedDriveFile
} from '../../../../types/google-drive.types';

export const receiveDocsGoogleDriveRequest = (data: any) => {
  return {
    type: RECEIVE_DOCS_GOOGLE_DRIVE_REQUEST,
    data,
  };
};

export const receiveDocsGoogleDriveSuccess = (data: any) => {
  return {
    type: RECEIVE_DOCS_GOOGLE_DRIVE_SUCCESS,
    data,
  };
};

export const receiveDocsGoogleDriveError = (error: unknown) => {
  return {
    type: RECEIVE_DOCS_GOOGLE_DRIVE_ERROR,
    error,
  };
};

export const sendNewFilesGoogleDriveRequest = (data: FormData): ISendNewFilesGoogleDriveRequestAction => {
  return {
    type: SEND_NEW_FILES_GOOGLE_DRIVE_REQUEST,
    data,
  };
};

export const sendNewFilesGoogleDriveSuccess = (data: IUploadedDriveFile[]): ISendNewFilesGoogleDriveSuccessAction => {
  return {
    type: SEND_NEW_FILES_GOOGLE_DRIVE_SUCCESS,
    data,
  };
};

export const sendNewFilesGoogleDriveError = (error: unknown): ISendNewFilesGoogleDriveErrorAction => {
  return {
    type: SEND_NEW_FILES_GOOGLE_DRIVE_ERROR,
    error,
  };
};

export const addNewFilesGoogleDriveRequest = (data: IUploadedDriveFile[], idFolder: string, id: number | string, types: string): IAddNewFilesGoogleDriveRequestAction => {
  return {
    type: ADD_NEW_FILES_GOOGLE_DRIVE_REQUEST,
    data,
    idFolder,
    id,
    types,
  };
};

export const addNewFilesGoogleDriveSuccess = (data: IUploadedDriveFile[]): IAddNewFilesGoogleDriveSuccessAction => {
  return {
    type: ADD_NEW_FILES_GOOGLE_DRIVE_SUCCESS,
    data,
  };
};
export const addNewFilesGoogleDriveError = (error: unknown): IAddNewFilesGoogleDriveErrorAction  => {
  return {
    type: ADD_NEW_FILES_GOOGLE_DRIVE_ERROR,
    error,
  };
};
